<template>
  <div id="page-user-view" style="width: 100%">
    <a-form :form="form"  @submit="handleSubmit">
      <ASpin type="loading" :spinning="loading">
        <vx-card title="افزودن کاربر">
          <div class="grid grid-col-1 sm:grid-cols-1 md:grid-cols-2 md:gap-2 lg:gap-4 xl:gap-4">
            <a-form-item label="نام" has-feedback>
              <a-input
                  v-decorator="['fname', { rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' },{ pattern:/^([\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C ])+$/,type:'string',message:'فیلد نام باید شامل حروف فارسی باشد.' }] }]"
                  autocomplete="off"
              />

            </a-form-item>
            <a-form-item label="نام خانوادگی" has-feedback>
              <a-input
                  v-decorator="['lname', { rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' },{ pattern:/^([\u0600-\u06FF\uFB8A\u067E\u0686\u06AF\u200C ])+$/,type:'string',message:'فیلد نام باید شامل حروف فارسی باشد.' }] }]"
                  autocomplete="off"
              />
            </a-form-item>
            <a-form-item label="شماره موبایل" has-feedback>
              <a-input
                  v-decorator="['mobile', { rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' },{pattern:/^(\+98|0098|98|0)?9\d{9}$/g,message:'فرمت شماره موبایل نادرست است.'},{ min:11,required: true, message: 'شماره موبایل باید 11 رقم باشد '}] }]"
                  placeholder="09XXXXXXXXX"
              />
            </a-form-item>
            <a-form-item label="نوع کاربری" has-feedback>
              <a-select
                  show-search
                  allowClear
                  placeholder="انتخاب کنید"
                  v-decorator="['user_type',{ rules: [{ required: true, message: 'وارد کردن مقدار الزامی است' }] }]"
              >
                <a-select-option v-for="item in userTypes" :value="item.id">
                  {{item.value}}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="رمز عبور" has-feedback>
              <a-input-password placeholder="رمز عبور خود را وارد کنید"
                  :autocomplete="false"
                  v-decorator="['password', { rules: [
                  { required: true, message: 'لطفا مقدار را وارد کنید' },
                  {min: 6, message: 'رمز عبور نباید کمتر از 6 کارکتر باشد' },
                  {max: 24, message: 'رمز عبور نباید بیشتر از 24 کارکتر باشد' },
                  ]}]"
              />
            </a-form-item>
            <a-form-item label="وضعیت">
              <a-switch checked-children="فعال" un-checked-children="غیر فعال" default-checked
                        v-decorator="['active', { valuePropName: 'checked' }]"/>
            </a-form-item>

          </div>
          <a-button @click="handleSubmit" type="primary" html-type="submit" class="mt-4">
            ثبت کاربر
          </a-button>

        </vx-card>
      </ASpin>
    </a-form>
  </div>
</template>


<script>
import axios from '@/axios'

export default {
  name: "create",
  components:{
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
      loading: false,
      userTypes:{}
    }
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async(err, values) => {
        if (!err) {
          try{
            this.loading = true
            await axios.post('/user',values)
            this.$ntSet()
            setTimeout(()=>{
              this.$router.push('/users')
            },500)
          }catch (e) {
            if(e.response.data.errors){
              let str_error = ''
              for (let x of Object.values(e.response.data.errors)){
                x.map(xx=>{
                  str_error += xx + "<br/>"
                })
              }
              this.$ntSetError(str_error)
            }
          }finally {
            this.loading = false
          }
        }

      });
    },
  },
  async created(){
    try{
      this.loading = true
      const { data } = await axios.get(`/permission/type`)
      this.userTypes = data
    }catch (e) {
      this.$ntSetError('خطا در دریافت اطلاعات')
    }finally {
      this.loading = false
    }
  }
}

</script>

<style>

.has-success.has-feedback .ant-form-item-children-icon{
  color: var(--vs-primary) !important;
}

</style>
